<div class="activity-details solo upload-activity" c-toggle="viewVisible"  c-toggle-options="{type: 'fade'}">
    <c-auto-form config="autoFormConfig"></c-auto-form>
</div>